import React from 'react';
import { useMutation } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';

const mutation = gql`
  mutation jobSignOffRevoke($cloudId: String!, $note: String!) {
    jobSignOffRevoke(input: { cloudId: $cloudId, note: $note }) {
      correlationId
      validationMessage {
        field
        message
      }
      messagesSuccessfullyProcessed
    }
  }
` as import('../../__generated__/ts-gql/jobSignOffRevoke').type;

export type JobSignOffRevokeVariables = OperationVariables<typeof mutation>;
export type JobSignOffRevokeResult = OperationData<typeof mutation>;

export const useJobSignOffRevoke = () => {
  const tuple = useMutation(mutation);

  const [_mutate, result] = tuple;

  const mutate = React.useCallback<typeof _mutate>(
    (options) =>
      _mutate({
        context: { service: 'core' },
        refetchQueries: [
          'GetJob',
          'GetJobComments',
          'GetNotificationCountForUser',
        ],
        // refetchQueries: [
        //   {
        //     query: getJobQuery,
        //     variables: { cloudId: options.variables.cloudId },
        //   },
        //   {
        //     query: getJobCommentsQuery,
        //     variables: { cloudId: options.variables.cloudId },
        //   },
        // ],
        awaitRefetchQueries: true,
        update(cache) {
          cache.evict({ fieldName: 'getJobSignOffs' });
        },
        ...options,
      }),
    [_mutate]
  );

  return React.useMemo<typeof tuple>(() => [mutate, result], [mutate, result]);
};
